class Training {
  constructor(root) {
    this.root = root;

    this.trainingSwiperEl = this.root.querySelector(
      ".js-training-story-swiper",
    );

    this.init();
    this.mount();
  }
  init() {
    this.storyModalSwiperEl && this.storyModalSwiper();
    this.trainingSwiperEl && this.trainingSwiper();
  }
  mount() {}
  trainingSwiper() {
    const progressBarEl = document.querySelector(
      ".js-training-story-swiper__progressbar",
    );
    new Swiper(this.trainingSwiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 12,
      pagination: {
        el: progressBarEl,
        type: "progressbar",
      },
    });
  }
}
